import { fetcher } from '#lib/backendFetcher';

/**
 * Fetches a free, no-credits live preview of how many Handelsregister companies
 * match the given HR search parameters. Powers the "Treffer-Trichter" in the
 * search popup. Germany-only; for other countries the backend returns
 * `available: false` with a zero total.
 *
 * @param {Object} searchParameters - HR search parameters (backend shape, as built by buildSearchParameters)
 * @returns {Promise<{total: number, stages: Array<{key: string, count: number}>, available: boolean}>}
 */
export const fetchHrMatchCount = async (searchParameters) => {
	return await fetcher('/api/v1/search/unified/countMatches', {
		method: 'POST',
		body: { searchParameters },
	});
};
